import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import DesignAddCard from './DesignAddCard'

import 'react-image-crop/dist/ReactCrop.css'

import { ASSET_URL } from '../../../constants/ApiEndpoints'
import { logEvent } from '../../../utils/firebase'
import { getMembershipType } from '../../../utils/getMembershipType'

const FileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`

const MemberFlag = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  font-size: 12px;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 3px 16px 3px 12px;
  display: flex;
  align-items: center;
`

const MemberBadge = styled.img`
  width: 25px;
  height: 25px;
  padding-right: 10px;
`

const DesignUploadMyRoomCard = ({ disable, onCrop, onClick }) => {
  const { root } = useSelector(state => state.myroom)
  const profile = useSelector(state => state.profile.me)
  const membershipInfo = getMembershipType(profile)
  const rFile = useRef()
  const [sqty, setSqty] = useState()

  useEffect(() => {
    if (!root) {
      setSqty()
      return
    }

    //const used = root.numUserTemplates || 0
    //const total = root.numSpaces || 0
    //setSqty('(' + used + '/' + total + ')')
  }, [root])

  const handleUpload = e => {
    e.preventDefault()

    logEvent('my_room_upload_browse_file', {
      content_type: 'my_room'
    })

    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = e => {
        onCrop(e.target.result)
        rFile.current.value = null
      }
      reader.readAsDataURL(file)
    }
  }

  const handleClick = e => {
    if (disable) {
      if (onClick) onClick()
    }
  }

  return (
    <>
      <FileInput
        ref={rFile}
        type="file"
        id="img"
        name="img"
        accept="image/png,image/jpeg"
        onChange={handleUpload}
        disabled={disable}
      />
      <label htmlFor="img">
        <DesignAddCard info={sqty} onClick={handleClick}>
          {!membershipInfo.isMember && (
            <MemberFlag>
              <MemberBadge
                src={ASSET_URL + 'designer/badge_membership_on.png'}
              />
              Become a member
            </MemberFlag>
          )}
        </DesignAddCard>
      </label>
    </>
  )
}

export default DesignUploadMyRoomCard
